import * as Yup from 'yup';

export const updateHeroSchema = Yup.object({
	books: Yup.array().min(1, 'required').required('required'),
});
